import React from 'react';
import { Link } from "react-router-dom";
import * as ROUTES from '../routes/routes';
import { Modal } from 'antd';
import logo from '../assets/images/logo.png';
import logo_change from '../assets/images/logo.svg';
import quick_checkup_img from '../assets/images/quick-checkup-img.svg';
import edit_icon from '../assets/images/edit-icon.svg';
import $ from 'jquery';




class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        $('.mobile-btn').on('click', function(){
            $('.btn-hamburger-col').toggleClass('active');
            $('.mobile-btn').toggleClass('active');
            $('.mobile-box').toggleClass('active');
            // $('body.fixed-header').toggleClass('sticky-body');
            $('body').toggleClass('overlay-appear');

            if ($('body').hasClass('sticky-body')) {
                $('body').removeClass('sticky-body');
            }
            else{
                $('body').addClass('sticky-body');
            }
        });
        $('.overlay-appear').on('click', function(){
            $('.btn-hamburger-col').removeClass('active');
        });
    }
    showModal = () => {
        this.setState({
          visible: true,
        });
    };
    hideModal = () => {
        this.setState({
          visible: false,
        });
    };

    contentChange = (e) => {
        e.preventDefault();
        $('.sign-in-modal-detail-wrapper').hide();
        $('.verify-section').show();
        // this.setState({
        //     visible:true,
        // });
    };
    editClick = (e) => {
        e.preventDefault();
        $('.sign-in-modal-detail-wrapper').show();
        $('.verify-section').hide();
    };
    

    render() {
        return (
            <>
                <div className="header-area ">
                {/* className={(this.props.prop.location.pathname == ROUTES.BUYGIFTCARD) ? "header-area buy-gift-card" : 'header-area'} */}
                    <div className="container">
                    <header className="row">
                        <div className="logo-col">
                            <Link to={ROUTES.HOME} title="PhleboIndia" className="logo">
                                <img src={logo} alt="PhleboIndia" className="img-fluid logo-image" />
                                <img src={logo_change} alt="PhleboIndia" className="img-fluid logo-change" />
                            </Link>
                        </div>
                        {/* <div className="btn-hamburger-col">
                            <button className="btn-hamburger mobile-btn">
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>
                        </div> */}
                            <div className="button-col">
                                <Link title="Login" className="common-btn dark-bg sing-up-btn" onClick={this.showModal}>Login / Sign Up</Link>
                            </div>
                            {/* // : ((this.props.prop.location.pathname == ROUTES.BUYGIFTCARD) ?
                            //     <div className="button-col">
                            //         <Link to="" title="Redeem" className="common-btn text-redeem">Redeem</Link>
                            //         <Link to="" title="Send Gift Card" className="common-btn dark-pink-bg">Send Gift Card</Link>
                            //     </div>
                            //     : '')} */}
                    </header>
                    </div>
                </div>

                <div className="modal-area">
                <Modal
                    className="login-modal modal-common"
                    title=""
                    visible={this.state.visible}
                    onCancel={this.hideModal}
                    transitionName=""
                    >
                        <div className="modal-quick-checkup-box active">
                            <div className="quick-checkup-main">
                                <div className="quick-checkup-area">
                                    <h2 className="quick-checkup-title title-text"><span className="bold">Quick</span> checkup</h2>

                                    <div className="quick-checkup-listing-area">
                                        <ul className="quick-checkup-listing-row">
                                            <li className="quick-checkup-listing-col">
                                                <p className="quick-checkup-text">Book lab tests</p>
                                            </li>
                                            <li className="quick-checkup-listing-col">
                                                <p className="quick-checkup-text">Fastest lab test reports</p>
                                            </li>
                                            <li className="quick-checkup-listing-col">
                                                <p className="quick-checkup-text">View your bookings</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="quick-checkup-image-box">
                                <img src={quick_checkup_img} alt="" />
                            </div> */}
                        </div>

                        <div className="signin-login-wrapper bg-white-wrapper">
                            <div className="sign-in-modal-detail-wrapper ">
                                <div className="sign-in-title-box">
                                    <h1 className="title-text">Log In / Sign Up</h1>
                                    <p className="description-text">Get access of your account to book lab tests or view bookings.</p>
                                </div>

                                <div className="sign-in-modal-form-area">
                                    <form className="sign-in-form">
                                        <div className="input-field-area">
                                            <div className="common-input-field-box phone-input-field common-input-field">
                                                <div className="phone-prefix-box">
                                                    +91
                                                </div>
                                                <input type="number" className="input-field" inputMode="numeric" placeholder="Mobile Number" />
                                            </div>
                                            <span className="label info-text">An OTP will be sent on this number.</span>
                                        </div>
                                        <button className="main-btn continue-btn" onClick={this.contentChange}>Continue</button>
                                    </form>

                                    <div className="modal-footer-text-area">
                                        <p className="modal-footer-text">
                                            By proceeding, you agree to our 
                                            <Link to="" className="link-text terms-link">Terms of Service</Link> & 
                                            <Link to="" className="link-text privacy-policy-link">Privacy Policy.</Link>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="verify-section" visible={this.state.visible}>
                                <div className="verify-title-box">
                                    <h1 className="title-text">Verify OTP</h1>
                                    <p className="verify-description-text">Enter 4 digit OTP sent on 
                                        <span className="bold"> +91 9465494645</span>
                                        <a href="javascript:void(0)" className="edit-icon-box" onClick={this.editClick}>
                                            <img src={edit_icon} alt="" />
                                        </a>
                                    </p>   
                                </div>
                                <div className="input-field-blocks">
                                    <div className="input-field-blocks-row">
                                        <div className="input-field-blocks-col">
                                            <div className="input-field-box">
                                                <input type="text" inputMode='numeric' className="common-input-field" maxLength={1}/>
                                            </div>
                                        </div>
                                        <div className="input-field-blocks-col">
                                            <div className="input-field-box">
                                                <input type="text" inputMode='numeric' className="common-input-field" maxLength={1}/>
                                            </div>
                                        </div>
                                        <div className="input-field-blocks-col">
                                            <div className="input-field-box">
                                                <input type="text" inputMode='numeric' className="common-input-field" maxLength={1}/>
                                            </div>
                                        </div>
                                        <div className="input-field-blocks-col">
                                            <div className="input-field-box">
                                                <input type="text" inputMode='numeric' className="common-input-field" maxLength={1}/>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="send-again-link-text">Didn't get OTP? <a href="#" className="send-link">Send it again</a></p>
                                </div>

                                <div className="modal-footer-text-area">
                                    <p className="modal-footer-text">
                                        By proceeding, you agree to our 
                                        <Link to="" className="link-text terms-link">Terms of Service</Link> & 
                                        <Link to="" className="link-text privacy-policy-link">Privacy Policy.</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                </Modal>
                </div>
            </>
        );
    }
};

export default Header;